import {
  IGroupedUnitAssignments,
  IStrataManager,
  IUnitStrataAssignments,
} from 'src/pages/Property/ManageStrataManagers/types';

export const groupUnitsByCommonArea = (
  units: IUnitStrataAssignments[]
): IGroupedUnitAssignments => {
  const commonAreas: IUnitStrataAssignments[] = units.filter(
    (unit: IUnitStrataAssignments) => unit.isCommonArea
  );

  const generalUnits: IUnitStrataAssignments[] = units.filter(
    (unit: IUnitStrataAssignments) => !unit.isCommonArea
  );

  return { commonAreas, generalUnits };
};

export const getAssignableManagerOptions = (
  assignedManagers: IStrataManager[],
  availableManagers: IStrataManager[]
): IStrataManager[] => {
  const assignedIds: Set<string> = new Set(
    assignedManagers.map((manager: IStrataManager) => manager.userId)
  );

  return availableManagers.filter(
    (manager: IStrataManager) => !assignedIds.has(manager.userId)
  );
};